var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.862,
    height: 14.52,
    viewBox: "0 0 11.862 14.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_delete",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35328",
    "data-name": "Path 35328",
    d: "M11.822,3.245,11.5,2.284a.894.894,0,0,0-.849-.612H7.958V.8A.8.8,0,0,0,7.163,0H4.7a.8.8,0,0,0-.8.8v.877h-2.7a.894.894,0,0,0-.849.612L.036,3.25A.72.72,0,0,0,.718,4.2h.335l.738,9.121A1.32,1.32,0,0,0,3.1,14.52H8.91a1.319,1.319,0,0,0,1.308-1.207l.738-9.121h.186a.719.719,0,0,0,.682-.947ZM4.751.85H7.107v.822H4.751ZM9.369,13.244a.464.464,0,0,1-.46.425H3.1a.464.464,0,0,1-.46-.425L1.907,4.192H10.1ZM.9,3.341l.263-.788a.044.044,0,0,1,.042-.03h9.446a.044.044,0,0,1,.042.03l.263.788Zm0,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35329",
    "data-name": "Path 35329",
    d: "M268.7,174.1h.022a.425.425,0,0,0,.424-.4l.4-7.669a.426.426,0,1,0-.85-.044l-.4,7.669a.425.425,0,0,0,.4.444Zm0,0",
    transform: "translate(-260.687 -160.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35330",
    "data-name": "Path 35330",
    d: "M106.212,173.7a.425.425,0,0,0,.424.4h.024a.425.425,0,0,0,.4-.448l-.418-7.669a.425.425,0,0,0-.849.046Zm0,0",
    transform: "translate(-102.793 -160.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35331",
    "data-name": "Path 35331",
    d: "M194.679,174.1a.425.425,0,0,0,.425-.425V166a.425.425,0,1,0-.851,0v7.669a.425.425,0,0,0,.426.431Zm0,0",
    transform: "translate(-188.745 -160.883)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.ea43a8c91d39a1d171397ad422fbfdb2.svg";
export { ForwardRef as ReactComponent };